import React, { useState } from "react"
import { Grid } from '@material-ui/core';
import { Tabs, Button, Row, Col } from 'antd';
import PageContainer from "../../../../../CSIComponents/PageContainer";
import DetailItem from "../../../../../CSIComponents/DetailItem";
const { TabPane } = Tabs;

const PaymentAddressDetails = (props: any) => {
  const rowDetail = JSON.parse(JSON.stringify(props.cancellationDetails))
  if (rowDetail.paymentaddress.length < 1) rowDetail.paymentaddress.push({ id: 1 })
  rowDetail.paymentaddress.forEach((item: any, index: number) => {
    const address: any = []
    const addressItem = Object.keys(item).filter((item1, index) => {
      return (item1 + '').startsWith('addressline')
    })
    addressItem.forEach((item2) => {
      if (item[item2] !== '' && item[item2] !== null) {
        address.push({ text: item[item2] })
      }
    })
    item.address = address;
    item.id = index + 1;
  })
  const panes = rowDetail.paymentaddress

  const [activeKey, setActiveKey] = useState<any>(JSON.stringify(panes[0]?.id))
  const onChange = (activeKey: any) => {

    setActiveKey(activeKey)
  };
  return (
    <>
      <PageContainer>
        <div style={{ background: '#fff', padding: '20px', position: 'relative' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.changeTab('GuaranteePayment') }}>Back</Button>
                    </div>
                    <div>
                        <Button className="db-edit-btn" onClick={() => { props.setActiveTabKey('PaymentAddress'); props.toggleToEditMode(); props?.payAddEditRef?.current?.resetRequired(true) }}>Edit</Button>
                    </div>
            </div>
          <Tabs
            type="card"
            onChange={onChange}
            activeKey={activeKey}
          >
            {panes.map((pane: any, i: number) => (
              <TabPane tab={'Payment Address ' + (i + 1)} key={i + 1 + ''}>
                <PageContainer>
                  <Grid item xs={12} className="pb-0 px-0 my-0">
                    <Row gutter={24}>
                      <Col span={12} className="col-margin">
                        <DetailItem value={pane.name} label='Address Name' />
                      </Col>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.type} label='Address Type' />
                      </Col>
                      <Col span={6}></Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.pobox} label='PO Box' />
                      </Col>
                    </Row>
                    {pane.address.map((address: any, index: number) => {
                      return <Row gutter={24} key={index}>
                        <Col span={18} className="col-margin">
                          <DetailItem value={address.text} label={'Address' + (index + 1)} />
                        </Col>
                        <Col span={6}></Col>
                      </Row>
                    })}
                    <Row gutter={24}>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.city} label='City' />
                      </Col>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.state} label='State/Province' />
                      </Col>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.country} label='Country' />
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6} className="col-margin">
                        <DetailItem value={pane.postalcode} label='Postal Code' />
                      </Col>
                    </Row>
                  </Grid>
                </PageContainer>
              </TabPane>
            ))}
          </Tabs>
        </div>
      </PageContainer>
    </>
  )
}

export default PaymentAddressDetails
